export default __webpack_public_path__ + "static/media/gift-cards-empty.4cfeebfa.svg";